import { FormikErrors, FormikTouched } from 'formik';
import { memo } from 'react';
import { DateTime } from 'luxon';
import { ActManagementForm } from 'shell/view-models/act-form';
import DocumentActForm from 'shell/components/shared/act';
import { emptyPaper } from 'shell/components/shared/act/constants';

interface BirthdayDocumentFormProps {
  values?: ActManagementForm;
  initialValues?: ActManagementForm;
  onChange: (
    key: keyof ActManagementForm,
    value: ActManagementForm[keyof ActManagementForm]
  ) => void;
  onChangeValues: (values: ActManagementForm) => void;
  resetForm: (values: ActManagementForm) => void;
  errors?: FormikErrors<ActManagementForm>;
  touched?: FormikTouched<ActManagementForm>;
  isAire?: boolean;
  disabled?: boolean;
  isTransferNew?: boolean;
  birthday?: DateTime | null;
  isBornSolo?: boolean;
}

const BirthdayDocumentFormComponent = ({
  initialValues = {},
  values,
  onChange,
  errors,
  touched,
  onChangeValues,
  isAire = false,
  isTransferNew,
  disabled,
  isBornSolo,
}: BirthdayDocumentFormProps): React.ReactElement => {
  return (
    <DocumentActForm
      initialValues={{
        paper: { ...emptyPaper, transcribed: initialValues.paper?.transcribed },
      }}
      values={values}
      onChange={(key, value) => {
        onChange(key, value);
      }}
      onChanges={(changeValues) => {
        onChangeValues(changeValues);
      }}
      errors={errors}
      touched={touched}
      visibilityPaper={{
        actDate: isTransferNew ? false : true,
      }}
      disabledPaper={{
        transcribed: isBornSolo ? false : isAire,
      }}
      disabled={disabled}
    />
  );
};

BirthdayDocumentFormComponent.displayName = 'Birthday document component';

const BirthdayDocumentForm = memo(BirthdayDocumentFormComponent);

export default BirthdayDocumentForm;
